import { updateObject } from './../../utils/utility';

const initialState = {
    companyList: [],
    hasServerResponded: false,
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    orderIds: [],
    legalEntityList: [],
    customizedReportsList: [],
    filters: {},
    isSubmitClicked: false,
    message: "",
    consolidatedReportList: [],
    consolidatedReportData: {},
    company: null
};

const setCompany = (state = initialState, action) => {
    const data = action.payload;
    return updateObject(state, {
        company: data
    });
}

const setIsSubmitClicked = (state = initialState, action) => {
    const data=action.payload;
    return updateObject(state, {
        isSubmitClicked: data
    });
};

const setFilters = (state = initialState, action) => {
    const data=action.payload;
    return updateObject(state, {
        filters: data
    });
};

const setCompanyList = (state = initialState, action) => {
    const data=action.payload.data;
    return updateObject(state, {
        companyList: data.companyList
    });
};

const setLegalEntityList = (state = initialState, action) => {
    const data=action.payload.data;
    return updateObject(state, {
        legalEntityList: data.legalEntityList
    });
};

const setHasResponded = (state = initialState, action) => {
    return updateObject(state, {
        hasServerResponded: action.data,
    });
};

const setCustomizedReportsList = (state = initialState, action) => {
    const { orderList,totalElements,pageNumber,totalPage,orderIds } = action.payload ;
    return updateObject(state, {
        customizedReportsList: orderList,
        totalElements,
        pageNumber,
        orderIds,
        totalPages: totalPage
    });
};

const setConsolidatedReport = (state = initialState, action) => {
    const data=action.payload.data;
    console.log("Message::"+JSON.stringify(data));
    return updateObject(state, {
        message: data
    });
};

const setConsolidatedReportList = (state = initialState, action) => {
    const data=action.payload.data;
    return updateObject(state, {
        consolidatedReportList: data.consolidatedReportList
    });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_HAS_CUSTOMIZED_REPORTS_RESPONDED") {
        return setHasResponded(state, action);
    }
    else if (action.type === "SET_LEGAL_ENTITY_LIST") {
        return setLegalEntityList(state, action);
    }
    else if (action.type === "SET_CUSTOMIZED_REPORTS_COMPANY_LIST") {
        return setCompanyList(state, action);
    }
    else if (action.type === "SET_CUSTOMIZED_REPORTS_LIST") {
        return setCustomizedReportsList(state, action);
    }
    else if (action.type === "SET_CUSTOMIZED_REPORTS_FILTERS") {
        return setFilters(state, action);
    }
    else if (action.type === "SET_IS_SUBMIT_CLICKED") {
        return setIsSubmitClicked(state, action);
    }
    else if (action.type === "SET_CONSOLIDATED_REPORT") {
        return setConsolidatedReport(state, action);
    }
    else if (action.type === "SET_CONSOLIDATED_REPORT_LIST") {
        return setConsolidatedReportList(state, action);
    }
    else if (action.type === "SET_COMPANY") {
        return setCompany(state, action);
    }
    
    return state;
};

export default reducer;